<template>
  <!-- <img class="order-mark" :src="svg" > -->
  <div class="mod-order-mark">
    <mark :class="['mark', isDark ? 'dark' : 'light']">
      {{ textMark }}
    </mark>
  </div>
</template>
<script>
export default {
  name: 'OrderMark',
  props: {
    isMainOrder: Boolean
  },
  computed: {
    isEn() {
      return this.$store.state.settings.language === 'en-us'
    },
    isDark() {
      const isdark = this.$store.state.settings.theme === 'theme-dark'
      return isdark
    },
    textMark() {
      let text = ''
      if (this.isEn) {
        if (this.isMainOrder) {
          text = 'M'
        } else {
          text = 'S'
        }
      } else {
        if (this.isMainOrder) {
          text = '主'
        } else {
          text = '附'
        }
      }
      return text
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.mod-order-mark {
  display: inline-block;
  width: 16px;
  height: 14px;
  overflow: hidden;
  border-radius: 2px;
}
.mark {
  display: inline-block;
  line-height: 28px;
  text-align: center;
  vertical-align: bottom;
  width: 34px;
  height: 28px;
  font-weight: 400;
  font-size: 20px;
  background-color: var(--active-color);
  color: var(--default-font-color);
  transform: scale(0.5);
  transform-origin: 0 0;
  margin-top: 0;
  overflow: hidden;
}
.light {
  color: #fff;
}
.dark {
  color: #000;
}
</style>
